import React, {useEffect, useState} from 'react';
import { renderDropdown, renderDropdownReadOnly} from "../../gdpr/ui/DropdownFunctions";
import SpinnerDiv from "../../gdpr/ui/SpinnerDiv";
import PropTypes from "prop-types";
import {getUsageReportsData} from "../../gdpr/ui/DropdownDataProviders";

const DropdownUsageReports = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getUsageReportsData(props.user, props.user_type).then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    const options = {
        isSearchable: true,
        isClearable: props.isClearable === null || props.isClearable === undefined ? true : props.isClearable,
    }

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data, options)
    )
}

export default DropdownUsageReports;

DropdownUsageReports.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownUsageReports.propTypes = {
    onChange: PropTypes.func.isRequired
};